import React from "react";

const context = React.createContext({ deviceCoupleList: [] });

export default context;
